module.exports = __webpack_public_path__ + "static/media/icon-remove-med.8a2dc1a5.svg";